import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useDetailsViewContext } from '../DetailsViewContext';

// import usePropsBeforeContext from '../../../../hooks/usePropsBeforeContext';

/**
 * Calendar section with title and calendar component
 */
const CalendarSection = () => {
  const {
    CalendarView,
    calendarTitle,
    calendarHeight,
    openProductPage,
    tslHeadlineRef,
    suppressDefaultInterfaces = true,
  } = useDetailsViewContext();

  // Add a safety check for CalendarView
  if (!CalendarView) {
    console.warn('CalendarView component is undefined in CalendarSection');
    return (
      <Grid
        id="calendar-section-warn"
        container
        item
        xs={12}
        sx={{
          alignContent: 'flex-start',
        }}
      >
        <Grid
          ref={tslHeadlineRef}
          item
          xs={12}
          sx={{
            pb: 1,
          }}
        >
          <Typography variant="h4" component="h2" sx={{ m: 0 }}>
            {calendarTitle || 'Calendar'}
          </Typography>
        </Grid>
        <Grid item container xs={12}>
          <Typography variant="body1" color="error">
            Calendar component not available
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      id="calendar-selection"
      container
      item
      xs={12}
      sx={{
        alignContent: 'flex-start',
      }}
    >
      <Grid
        ref={tslHeadlineRef}
        item
        xs={12}
        sx={{
          pb: 1,
        }}
      >
        <Typography variant="h4" component="h2" sx={{ m: 0 }}>
          {calendarTitle}
        </Typography>
      </Grid>
      <Grid item container xs={12}>
        <CalendarView
          suppressDefaultInterfaces={suppressDefaultInterfaces}
          openProductPage={openProductPage}
          openResourcePage={undefined}
          height={calendarHeight}
        />
      </Grid>
    </Grid>
  );
};

CalendarSection.displayName = 'CalendarSection';

export default CalendarSection;
